import { useEventTagContext } from "../../../context/EventTagContext/EventTagContext";
import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import { EventTagRules } from "../../../context/EventTagContext/constants";
import IconPicker from "../../../components/IconPicker";
import { EventTagCultureLabels } from "./constants";

const EventTagForm = () => {
	const { addEventTagForm: eventTagForm, setAddEventTagForm: setEventTagForm } = useEventTagContext();

	const handleTagNameChange = (culture: string, value: string) => {
		setEventTagForm(prev => ({
			...prev,
			eventTagLocalizable: prev.eventTagLocalizable.map(item =>
				item.culture === culture ? { ...item, tagName: value } : item
			),
		}));
	};

	return (
		<>
			<Row gutter={[20, 16]}>
				<Col xs={24} lg={10}>
					<IconPicker
						title="İkon"
						isRequired
						value={eventTagForm.tagIcon}
						onChange={iconName => setEventTagForm(prev => ({ ...prev, tagIcon: iconName }))}
					/>
				</Col>
				<Col xs={24} lg={10}>
					{eventTagForm.eventTagLocalizable.map(item => (
						<InputComponent
							key={item.culture}
							title={EventTagCultureLabels[item.culture] ?? item.culture}
							isRequired
							value={item.tagName}
							maxLength={EventTagRules.tagNameMaxLength}
							onChange={e => handleTagNameChange(item.culture, e.target.value)}
						/>
					))}
				</Col>
			</Row>
		</>
	);
};

export default EventTagForm;
